var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnstoppable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.522,
    height: 26.588,
    viewBox: "0 0 25.522 26.588",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_55604",
    "data-name": "Group 55604",
    transform: "translate(-390.74 -389.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_521",
    "data-name": "Path 521",
    transform: "translate(396.553 394.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85460",
    "data-name": "Path 85460",
    d: "M412.039,401.031h-2.081v-3.282a2.5,2.5,0,0,0-.706-1.722l-1.722-1.709a2.438,2.438,0,0,0-1.722-.718h-5.994a2.137,2.137,0,0,0-1.523.644l-2.13,2.118a2.172,2.172,0,0,0,1.536,3.7,2.229,2.229,0,0,0,1.536-.632l1.486-1.5h1.053l-3.257,3.257a2.945,2.945,0,0,0,0,4.149l2.861,2.861v4.3a2.442,2.442,0,0,0,2.427,2.44h.669l-.074-.087a2.456,2.456,0,0,0,1.845-2.366v-5.313a2.46,2.46,0,0,0-.718-1.721L404,403.929l1.622-1.622v.632a2.431,2.431,0,0,0,2.428,2.427h3.988a2.167,2.167,0,0,0,0-4.335Zm0,2.663h-3.976a.751.751,0,0,1-.755-.755v-4.682l-5.685,5.685,2.712,2.725a.742.742,0,0,1,.223.52V412.5a.751.751,0,0,1-.755.756.759.759,0,0,1-.755-.756v-4.991l-3.344-3.344a1.269,1.269,0,0,1-.359-.879,1.2,1.2,0,0,1,.359-.892l6.131-6.131h-5.809l-1.969,1.969a.5.5,0,0,1-.842-.334.486.486,0,0,1,.136-.347l2.13-2.118a.45.45,0,0,1,.347-.149h5.982a.74.74,0,0,1,.533.223l1.721,1.721a.748.748,0,0,1,.223.533v4.954h3.753a.489.489,0,1,1,0,.978Z",
    transform: "translate(-395.53 -393.6)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_522",
    "data-name": "Path 522",
    transform: "translate(391.24 403.459)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85461",
    "data-name": "Path 85461",
    d: "M401.185,405.631l-2.613,2.613a2.421,2.421,0,0,1-1.7.706h-.025a2.41,2.41,0,0,1-1.709-.718l-3.183-3.183a2.36,2.36,0,0,1-.718-1.709,2.432,2.432,0,0,1,2.428-2.44h.025a2.421,2.421,0,0,1,1.7.706l1.474,1.474.991-.991,1.189,1.189-2.192,2.18-2.65-2.663a.762.762,0,0,0-1.288.545.742.742,0,0,0,.223.52l3.2,3.2a.759.759,0,0,0,1.065-.012l2.6-2.6Z",
    transform: "translate(-391.24 -400.9)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_523",
    "data-name": "Path 523",
    transform: "translate(408.777 390.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55603",
    "data-name": "Group 55603"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85462",
    "data-name": "Path 85462",
    d: "M408.893,390.17a3.5,3.5,0,1,0,3.493,3.493A3.5,3.5,0,0,0,408.893,390.17Zm0,5.313a1.814,1.814,0,1,1,1.821-1.821A1.824,1.824,0,0,1,408.893,395.483Z",
    transform: "translate(-405.4 -390.17)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstoppable);
export default __webpack_public_path__ + "static/media/unstoppable.f98bc02f963c4bd66978e8738bd0179c.svg";
export { ForwardRef as ReactComponent };